module.exports = __webpack_public_path__ + "img/k8s.7af646b1.png";